var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{staticClass:"rounded-lg white--text",attrs:{"value":_vm.selectedTab,"background-color":"secondary","active-class":"primary","color":"#FF8700"}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{staticClass:"white--text mr-2",on:{"click":function($event){return _vm.changeRoute(tab)}}},[_vm._v(_vm._s(tab.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }